// src/components/BotConnection/BotConnectionHeader.jsx
import React, { useState } from 'react';

const BotConnectionHeader = () => {

    // Removed ipAddress state and handlers
   
     return (
       // Keep mb-8 for spacing before ServerInfoCard
       <div className="mb-8 transform-gpu hover:scale-[1.01] transition-medium">
         <div className="relative overflow-hidden bg-gradient-to-r from-dark-600 via-dark-500 to-dark-600 rounded-2xl p-6 md:p-8 border border-dark-400 hover:border-accent-purple/30 transition-medium group">
           {/* Background effects */}
           <div className="absolute -right-10 -bottom-20 w-72 h-72 bg-accent-purple opacity-[0.03] rounded-full blur-3xl animate-pulse-slow group-hover:opacity-[0.06] transition-opacity duration-300"></div>
           <div className="absolute -left-10 -top-20 w-64 h-64 bg-accent-blue opacity-[0.03] rounded-full blur-3xl animate-pulse-slow group-hover:opacity-[0.06] transition-opacity duration-300"></div>
           <div
               className="absolute inset-0 bg-repeat opacity-[0.02] group-hover:opacity-[0.04] transition-opacity duration-300"
               style={{
                   backgroundImage: `linear-gradient(to right, ${'#474063'} 1px, transparent 1px), linear-gradient(to bottom, ${'#474063'} 1px, transparent 1px)`,
                   backgroundSize: '20px 20px',
               }}
           ></div>
   
           <div className="flex flex-col md:flex-row items-center justify-between z-10 relative">
             {/* Left side: Text */}
             <div className="w-full md:w-2/3 lg:w-1/2 mb-6 md:mb-0 text-center md:text-left">
               <div className="inline-flex items-center text-sm font-medium text-accent-purple mb-2 animate-pulse-slow bg-accent-purple/10 px-3 py-1 rounded-full">
                 <i className="fas fa-robot mr-2"></i>
                 BOT CONNECTION MODULE
               </div>
               <h2 className="text-3xl font-bold mb-3 group-hover:text-white transition-colors">
                 Establish Bot
                 <span className="gradient-text inline-block ml-2 group-hover:animate-pulse-text bg-gradient-to-r from-accent-purple to-accent-blue">Nexus</span>
               </h2>
               <p className="text-gray-400 text-sm max-w-md mx-auto md:mx-0 group-hover:text-gray-300 transition-colors">
                 Connect to a target server below to prepare for bot deployment. Basic server information will be verified upon connection.
               </p>
               {/* Input and Button Area REMOVED */}
             </div>
   
             {/* Right side: Bot/Network Themed Graphic */}
             <div className="w-full md:w-1/3 lg:w-1/2 md:pl-8 flex items-center justify-center mt-8 md:mt-0 h-48 md:h-auto group-hover:scale-105 transition-transform duration-500">
                <div className="relative w-full h-full max-w-[250px] aspect-square">
                    {/* Central Bot Icon */}
                    <div className="absolute inset-[25%] z-10 flex items-center justify-center animate-float">
                       <div className="p-3 rounded-full bg-dark-700 shadow-lg border border-accent-purple/30 group-hover:shadow-accent-purple/20 transition-shadow duration-300">
                            <i className="fas fa-robot text-5xl text-accent-purple opacity-90"></i>
                       </div>
                    </div>
                    {/* SVG and Rings... (keep as is) */}
                     <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full opacity-40 group-hover:opacity-60 transition-opacity duration-300 overflow-visible">
                       {[0, 45, 90, 135, 180, 225, 270, 315].map(angle => (
                           <line
                               key={`line-${angle}`}
                               x1="50"
                               y1="50"
                               x2={50 + 45 * Math.cos(angle * Math.PI / 180)}
                               y2={50 + 45 * Math.sin(angle * Math.PI / 180)}
                               stroke="url(#lineGradient)"
                               strokeWidth="0.5"
                               className="animate-draw-line"
                               style={{ animationDelay: `${(angle / 45) * 0.1}s` }}
                           />
                       ))}
                        {[0, 90, 180, 270].map(angle => (
                           <circle
                               key={`node-${angle}`}
                               cx={50 + 45 * Math.cos(angle * Math.PI / 180)}
                               cy={50 + 45 * Math.sin(angle * Math.PI / 180)}
                               r="1.5"
                               fill="currentColor"
                               className="text-accent-blue animate-ping-slow"
                               style={{ animationDelay: `${(angle / 90) * 0.3 + 0.5}s` }}
                           />
                        ))}
                         <defs>
                           <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                               <stop offset="0%" stopColor="#3ca9ff" stopOpacity="0" />
                               <stop offset="50%" stopColor="#3ca9ff" stopOpacity="1"/>
                               <stop offset="100%" stopColor="#9e3eff" stopOpacity="1"/>
                           </linearGradient>
                       </defs>
                    </svg>
                    <div className="absolute inset-0 rounded-full border border-accent-blue/10 animate-pulse-slow delay-500 group-hover:border-accent-blue/20 transition-colors duration-300"></div>
                    <div className="absolute inset-[10%] rounded-full border border-dashed border-accent-purple/10 animate-pulse-slow group-hover:border-accent-purple/20 transition-colors duration-300"></div>
               </div>
             </div>
           </div>
         </div>
       </div>
     );
   };

export default BotConnectionHeader;